import { useState, useCallback } from "react";
export function useNotificationFilters(initialFilters) {
    const [filters, setFilters] = useState(initialFilters || {});
    const updateFilter = useCallback((key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));
    }, []);
    const setTypeFilter = useCallback((type) => {
        updateFilter("type", type);
    }, [updateFilter]);
    const setReadFilter = useCallback((read) => {
        updateFilter("read", read);
    }, [updateFilter]);
    const setDateRangeFilter = useCallback((dateRange) => {
        updateFilter("dateRange", dateRange);
    }, [updateFilter]);
    const clearFilters = useCallback(() => {
        setFilters({});
    }, []);
    const hasActiveFilters = Object.keys(filters).length > 0;
    return {
        filters,
        setTypeFilter,
        setReadFilter,
        setDateRangeFilter,
        clearFilters,
        hasActiveFilters,
    };
}
